<template>
  <v-container id="content">
    <div>
      <span> Test application to explore and manage NFTs on the Hive Engine sidechain </span>
      <br>
      <span style="color: red"> This is still work in progress, so there may be bugs and a lot of features are missing. Use at your own risk!
      </span>
    </div>
    <br>
    <div style="width: 80%">
      <div class="grid">
        <div class="square" @click="linkToInventory">
          <div>
            Inventory
            <ul id="inventoryFeatures">
              <li>View your Rising Star and dCrops Inventory</li>
              <li>Transfer them to other players</li>
            </ul>
          </div>
        </div>
        <div class="square" @click="linkToMarket">
          <v-hover>
            <div>
            Market
              <ul id="marketFeatures">
              <li>View the Rising Star Market</li>
              <li>Purchase one or multiple NFTs</li>
            </ul>
          </div>
          </v-hover>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',
    methods: {
      linkToMarket() {
        this.$router.push('/market/' + this.$store.state.selectedTable.symbol);
      },
      linkToInventory() {
        this.$router.push('/inventory/' + this.$store.state.selectedTable.symbol + '/' +  this.$store.state.user);
      }
    }
  }
</script>

<style scoped>
#content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2%;
}

.square {
  aspect-ratio: 1/ 1;
  display: flex;
  padding: 5%;
  background: linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(72, 214, 43, 1) 21%, rgba(0, 212, 255, 1) 76%) fixed;
  min-width: 25%;

  justify-content: center;
  align-items: center;


  color: rgba(0, 0, 0, 0.5);
  font-size: 3em;
  font-family: Arial, sans-serif;

  transition: background 0.5s linear;
}

.square:hover {
  filter: drop-shadow(3px 3px 3px #42b983);
}

a {
  color: inherit;
}

li {
  font-size: 0.5em;
}
</style>